import { collapsedAtom, openKeysAtom, pageTabsAtom } from '@/layouts/BasicLayout/store';
import { type Route, useMenus } from '@/routes';
import { Menu } from '@arco-design/web-react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { pageRoutes } from '@/routes/routes';

const MenuItem = Menu.Item;
const { SubMenu } = Menu;

const Wrapper = styled.div`
  overflow: auto;
  height: 100%;

  :global(.arco-menu-item-inner > a::after),
  :global(.arco-menu-item > a::after) {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  :global(.arco-menu-inline-header) {
    font-weight: 500;
  }
`;

export function NavMenus() {
  const location = useLocation();
  const menus = useMenus();
  const [openKeys, setOpenKeys] = useAtom(openKeysAtom);
  const [pageTabs, setPageTabs] = useAtom(pageTabsAtom);
  const [collapsed] = useAtom(collapsedAtom);
  const navigate = useNavigate();
  const MenuNotes = useMemo(() => {
    return (function travel(routes: Route[]) {
      return routes.map((item) => {
        // 1.对group的处理
        if (item.icon) {
          if (item.children && item.children.length > 0) {
            return (
              <SubMenu
                key={item.path as string}
                title={
                  <>
                    {item.icon}
                    {item.name}
                  </>
                }
              >
                {travel(item.children!)}
              </SubMenu>
            );
          } else {
            return null;
          }
        }
        // 2.对item的处理
        return <MenuItem key={item.path!}>{item.name}</MenuItem>;
      });
    })(menus);
  }, []);
  return (
    <Wrapper>
      <Menu
        selectedKeys={[location.pathname]}
        openKeys={openKeys}
        collapse={collapsed}
        onClickMenuItem={(key) => {
          navigate(key);
          // 如果 key 不在当前的 pageTabs 中，则插入
          if (!pageTabs.some((v) => v.url === key)) {
            const title = pageRoutes.find((v) => v.path === key)?.name;
            setPageTabs((prev) => {
              return [
                ...prev,
                {
                  url: key,
                  title: title,
                },
              ];
            });
          }
        }}
        onClickSubMenu={(_, openKeys) => {
          setOpenKeys(openKeys);
        }}
      >
        {MenuNotes}
      </Menu>
    </Wrapper>
  );
}
